import { call, put, all, StrictEffect, takeLatest, takeEvery } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';
import { filterSeatAvailable } from '@utils/utils';

const searchRoute = `${DomainByEnv()}/search`;
// const searchRoute = `${DomainByEnv(false)}/local/search`;
const comfirantionRute = `${DomainByEnv()}/confirmation`;
// const comfirantionRute = `${DomainByEnv(false)}/local/confirmation`;

//查詢機票API
function* setSearchPriceAsync(action: any): Generator<StrictEffect, any, any> {
    const SearchPrice = yield call(fetchAPI, {
        // url: `${searchRoute}/searchprice`,
        url: `${searchRoute}/getflightsearchinfo`,
        req: action.payload,
    });
    if (SearchPrice?.FlightInfos && SearchPrice?.FlightInfos.length > 0) {
        SearchPrice.FlightInfos = filterSeatAvailable(SearchPrice.FlightInfos);
    }
    yield put(actions.setSearchPriceSuccess(SearchPrice));
    yield put(actions.setNoticeInfo(SearchPrice.NoticeInfo));
    yield put(actions.setSaleInfo(SearchPrice.SaleInfo));
}


function* watchsetSearchPriceAsync() {
    console.log('watchsetSearchPriceAsync');
    yield takeLatest(actionTypes.SET_SEARCHPRICE, setSearchPriceAsync);
}

function* setSearchInfoCalendarAsync(action: any): Generator<StrictEffect, any, any> {
    const SearchInfoCalendar = yield call(fetchAPI, {
        url: `${searchRoute}/getsearchinfocalendar`,
        req: action.payload,
    });
    yield put(actions.setSearchInfoCalendarSuccess(SearchInfoCalendar));
}

function* watchSetSearchInfoCalendarAsync() {
    console.log('watchSetSearchInfoCalendarAsync');
    yield takeLatest(actionTypes.SET_SEARCHINFOCALENDAR, setSearchInfoCalendarAsync);
}

function* setSearchInfoCalendarBarAsync(action: any): Generator<StrictEffect, any, any> {
    const SearchInfoCalendarBar = yield call(fetchAPI, {
        url: `${searchRoute}/getsearchinfocalendar`,
        req: action.payload,
    });
    yield put(actions.setSearchInfoCalendarBarSuccess(SearchInfoCalendarBar));
}

function* watchSetSearchInfoCalendarBarAsync() {
    console.log('watchSetSearchInfoCalendarBarAsync');
    yield takeLatest(actionTypes.SET_SEARCHINFOCALENDAR_BAR, setSearchInfoCalendarBarAsync);
}

//minrule票規API(for票)
function* setMiniRuleInfoAsync(action: any): Generator<StrictEffect, any, any> {
    const Miniruleinfo = yield call(fetchAPI, {
        // url: `${searchRoute}/miniruleinfo`,
        url: `${comfirantionRute}/flightminirule`,
        req: action.payload,
    });
    yield put(actions.setMiniRuleInfoSuccess(Miniruleinfo));
}

function* watchMiniRuleInfoAsync() {
    console.log('watchMiniRuleInfoAsync');
    yield takeLatest(actionTypes.SET_MINIRULEINFO, setMiniRuleInfoAsync);
}

//fareRuleInfo serp 票規API(for 業務 )
function* setFareRuleInfoAsync(action: any): Generator<StrictEffect, any, any> {
    const FareRuleInfo = yield call(fetchAPI, {
        url: `${comfirantionRute}/flightfarerule`,
        req: action.payload,
    });
    yield put(actions.setFareRuleInfoSuccess(FareRuleInfo));
}

function* watchFareRuleInfoAsync() {
    console.log('watchFareRuleInfoAsync');
    yield takeLatest(actionTypes.SET_FARERULEINFO, setFareRuleInfoAsync);
}


//固定票規API(for航司)
function* setFlightFixedRuleAsync(action: any): Generator<StrictEffect, any, any> {
    const FlightFixedRule = yield call(fetchAPI, {
        // url: `${comfirantionRute}/flightfixedrule`,
        url: `${comfirantionRute}/flightfixedrule`,
        req: action.payload,
    });
    yield put(actions.setFlightFixedRuleSuccess(FlightFixedRule));
}

function* watchFlightFixedRuleAsync() {
    console.log('watchFlightFixedRuleAsync');
    yield takeLatest(actionTypes.SET_FLIGHTFIXEDRULE, setFlightFixedRuleAsync);
}

export default function* rootSaga() {
    yield all([watchsetSearchPriceAsync(), watchSetSearchInfoCalendarAsync(), watchSetSearchInfoCalendarBarAsync(), watchMiniRuleInfoAsync(), watchFlightFixedRuleAsync(), watchFareRuleInfoAsync()]);
}
